import { throwError as observableThrowError } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ModaleErroreStore } from "../store/modale-errore.store";
import { env } from "@env/environment";
import { MembroVO } from "../vo/membroVO";
import { MembroDTO } from "../dto/membroDTO";
import { MapperMembro } from "../mapper/mapper-membro";

@Injectable({
  providedIn: "root",
})
export class MembroService {
  private urlMembro =
    env.DOCUMENTALE_ATTI_API_URL_BASE +
    env.API_DOCUMENTALE_ATTO + "membro/";

  constructor(
    private httpClient: HttpClient,
    private modaleErroreStore: ModaleErroreStore,
    private membroMapper: MapperMembro
  ) { }

  salvaMembro(request: MembroDTO): Observable<string> {
    // esegue la convesione vo -> dto


    console.log(
      "[MembroServiceComponent][salvaAtto] url: ",
      this.urlMembro
    );



    return this.httpClient
      .post(this.urlMembro, request, { observe: "response" })
      .pipe(
        map((response) => response.headers.get("Location")),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }


  aggiornaMembro(request: MembroDTO): Observable<void | object> {
    // esegue la convesione vo -> dto


    console.log(
      "[MembroServiceComponent][salvaAtto] url: ",
      this.urlMembro
    );



    return this.httpClient
      .put(this.urlMembro + request.id, request, { observe: "response" })
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }







  eliminaMembro(id: string): Observable<void | object> {
    // esegue la convesione vo -> dto


    console.log(
      "[MembroServiceComponent][eliminaMembro] url: ",
      this.urlMembro
    );

    return this.httpClient
      .delete(this.urlMembro + id)
      .pipe(
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }




  recuperaMembroById(idMembro: string): Observable<MembroVO> {
    console.log(
      "[MembroServiceComponent][recuperaAttoById] url: ",
      this.urlMembro
    );

    return this.httpClient
      .get(this.urlMembro + idMembro)
      .pipe(
        map((response: MembroDTO) =>
          this.membroMapper.convertDtoToVo(response)),
        catchError((err) => {
          this.modaleErroreStore.sendErrore(err);
          return observableThrowError(err); // observable needs to be returned or exception raised
        })
      );
  }


  listaMembri(
  ): Observable<MembroVO[]> {
    let url = this.urlMembro;
    console.log("[MembroServiceComponent][ricercaAvanzata] url", url);
    return this.httpClient.get(url).pipe(
      map(
        (resultList: MembroDTO[]) =>
          this.membroMapper.convertListDtoToVo(resultList) // creare result list e filtro
      ),
      catchError((err) => {
        this.modaleErroreStore.sendErrore(err);
        return observableThrowError(err); // observable needs to be returned or exception raised
      })
    );
  }



}
